<template>
  <div class="sidebar-inner">
    <!-- Top section -->
    <div class="top-section">
      <h4 class="mb-1">Contacts</h4>
      <hr>
      <contact v-for="contact in ticket.contacts" :key="contact.id" :contact="contact"></contact>
    </div>
    <!-- / Top section -->
    <!-- Bottom section -->
    <div class="bottom-section pt-3 pb-3">
      <add-contact-modal :ticket-id="ticket.id" @contact-added="reloadTicket"></add-contact-modal>
      <a href="#" @click.prevent="openAddContactModal" class="btn btn-itg-dark btn-block">
        <i class="fa fa-plus-circle mr-1"></i>
        Add Contact
      </a>
    </div>
    <!-- / Bottom section -->
  </div>
</template>

<script>
import Forms from "../../../../../mixins/Forms";
import Tickets from "../../../../../mixins/Tickets";
import AddContactModal from "./../widgets/AddContactModal";
import Contact from "./../widgets/Contact";
import {mapGetters, mapActions} from "vuex";

export default {
  name: "ContactSidebar",
  mixins: [Forms, Tickets],
  data() {
    return {}
  },
  created() {
  },
  components: {AddContactModal, Contact},
  computed: {
    ...mapGetters('ticketViewer', {
      ticket: 'ticket'
    })
  },
  methods: {
    ...mapActions('ticketViewer', {
      reloadTicket: 'reloadTicket'
    }),

    openAddContactModal() {
      this.$bvModal.show('add-contact-modal');
    }
  }
}
</script>

<style scoped>

</style>
